import React from 'react'
import _ from 'lodash'
import { Row } from 'antd'
import { P } from 'konsys-ui'
import contents from './detail/contents'
import ComponentRenderer from './detail/component-renderer'
import { Wrapper } from '../../components/truck-components'
import { detailMode } from './constants'
import history from '../../history'

const RowRenderer = ({
  data, mode, onChangeHandler, initialData, selectedData, mutationVariables, disableButton, setDisableButton,
}) => (
  data.map(v => <ComponentRenderer
    onChangeHandler={(id, value, optional) => onChangeHandler(id, value, optional)}
    key={v.id}
    data={v}
    mode={mode}
    initialData={initialData}
    selectedData={selectedData}
    mutationVariables={mutationVariables}
    disableButton={disableButton}
    setDisableButton={setDisableButton}
  />)
)

const DetailModeHandler = (params, onChangeHandler, mutationVariables, selectedData, disableButton, setDisableButton, initialData) => {
  const mode = params.mode.toUpperCase()
  switch (mode) {
    case detailMode.ADD:
      return contents.map((v, i) => (
        <Wrapper key={i}>
          <Row
            align='flex-start'
            type='flex'
            gutter={16}
          >
            <RowRenderer data={v} mode={mode} selectedData={selectedData} onChangeHandler={(id, value, optional) => onChangeHandler(id, value, optional)} mutationVariables={mutationVariables} disableButton={disableButton} setDisableButton={setDisableButton}/>
          </Row>
        </Wrapper>
      ))
    case detailMode.EDIT:
    case detailMode.VIEW:
    {
      if (_.isUndefined(params.id)) history.push('/truck')
      return contents.map((v, i) => (
        <Wrapper key={i}>
          <Row
            align='flex-start'
            type='flex'
            gutter={16}
          >
            <RowRenderer data={v} mode={mode} selectedData={selectedData} initialData={initialData} onChangeHandler={(id, value, optional) => onChangeHandler(id, value, optional)} mutationVariables={mutationVariables} disableButton={disableButton} setDisableButton={setDisableButton}/>
          </Row>
        </Wrapper>
      ))
    }
    case detailMode.DELETE:
    default:
      return <P>Something went wrong!</P>
  }
}

export default DetailModeHandler
